<template>
    <div class="pp-popup-picker__wrap">
        <pInput ref="input" :value="currentLabel"
            :size="currentSize"
            :placeholder="$attrs.placeholder === undefined ? '请选择' : $attrs.placeholder"
            v-bind="$attrs"
            readonly
            :disabled="currentDisabled"
            :clearable="clearable"
            @focus="inputFocus"
            @clear="inputClear">
        </pInput>
        <Popup ref="popup" class="pp-popup-picker pp-popup-date-time"
            :visible.sync="showPopup" 
            v-bind="$attrs"
            animate="bottom" :show-close="false">
            <header slot="title" class="pp-popup-picker__header">
                <span class="pp-popup-picker__header-cancel"
                    @click="close">
                    取消
                </span>
                <span>请选择</span>
                <span class="pp-popup-picker__header-submit"
                    @click="sure">
                    确定
                </span>
            </header>
            <div class="pp-date-time-picker">
                <pDate v-if="type !== 'time'" ref="date"></pDate>
                <pTime v-if="type !== 'date'" ref="time"></pTime>
            </div>
        </Popup>
    </div>
</template>

<script>
import Popup from '../../popup'
import pInput from '../../input'
import pDate from './date-item.vue'
import pTime from './time-item.vue'
import EventBus from '../../../src/util/event-bus.js'
import { paddingZero, dateFormat } from '../../../src/util/common.js'

/**
 * 时间选择器
 * @param {String, Number} value v-model绑定值
 * @param {String} type 选择器类型['date', 'date-time', 'time']
 * @param {String} size 尺寸
 * @param {Boolean} disabled
 * @param {String} format 显示在输入框的格式化 default: 'yyyy-MM-dd hh:mm:ss'
 * @param {String} valueFormat v-model值的格式化
 * @param {Boolean} clearable 显示清除按钮
 */
export default {
    name: 'pp-date-picker',
    inheritAttrs: false,
    components: {
        pDate, pTime, Popup, pInput
    },
    provide: function() {
        return {
            DateTimePicker: this,
        };
    },
    inject: {
        Form: {
            default: ''
        },
        FormItem: {
            default: ''
        },
    },
    props: {
        value: [String, Number],
        type: {
            type: String, 
            default: 'date',
            validator: function(value) {
                return ['date', 'date-time', 'time'].includes(value);
            },
        },
        size: {
            type: String,
            default: 'normal',
            validator: function(value) {
                return ['normal', 'small', 'mini'].includes(value);
            },
        },
        disabled: Boolean,
        clearable: Boolean,
        format: {
            type: String,
            default: 'yyyy-MM-dd hh:mm:ss',
        },
        valueFormat: String,
    },
    data: function() {
        return {
            currentValue: null,
            currentLabel: '',
            timeStamp: '',
            popup: null,
            showPopup: false,
            dateTime: {}, 
        };
    },
    computed: {
        currentSize: function() {
            return this.Form.size || this.FormItem.size || this.size;
        },
        currentDisabled: function() {
            return this.Form.disabled || this.disabled;
        },
    },
    watch: {
        showPopup: function(n) {
            if(!n) {
                this.inputBlur()
            }
        },
        value: function(n) {
            this.initValue(n)
        },
    },
    mounted: function() {
        this.initValue(this.value)
        this.createPopupToRoot()
    },
    methods: {
        initValue: function(value) {
            let date = value ? new Date(value) : new Date();

            this.currentValue = value
            this.currentLabel = this.formatter(value)
            this.timeStamp = date.getTime()
            this.dateTime = {
                years: date.getFullYear(),
                months: date.getMonth() + 1,
                dates: date.getDate(),
                hours: date.getHours(),
                minutes: date.getMinutes(),
                seconds: date.getSeconds()
            }
        },

        inputFocus: function(e) {
            this.$emit('focus', {
                event: e,
                value: this.valueFormatter(this.timeStamp)
            })
            this.showPopup = true
        },

        inputBlur: function(e) {
            this.$emit('blur', 
                this.valueFormatter(this.timeStamp))

            EventBus.formItemTrigger.apply(this, ['blur', this.valueFormatter(this.timeStamp)])
        },

        inputChange: function() {
            this.$emit('change', 
                this.valueFormatter(this.timeStamp))

            EventBus.formItemTrigger.apply(this, ['change', this.valueFormatter(this.timeStamp)])
        },

        inputClear: function() {
            this.$emit('clear')
            this.$emit('input', '')
        },

        focus: function() {
            this.$refs['input'].focus()
        },

        blur: function() {
            this.$refs['input'].blur()
            this.showPopup = false
        },

        update: function(value) {
            this.dateTime = Object.assign({}, this.dateTime, value)
            
            let date = this.getDate(this.dateTime);

            this.timeStamp = date.getTime()
        },

        sure: function() {
            this.$emit(
                'input',
                this.valueFormatter(this.timeStamp)
            )
            this.inputChange()
            this.close()
        },

        close: function() {
            this.showPopup = false
        },

        createPopupToRoot: function() {
            this.popup = this.$refs['popup']
            document.body.appendChild(this.popup.$el)
        },

        formatter: function(value) {
            return dateFormat(value, this.format);
        },

        getDate: function(obj) {
            return new Date(`${obj.years}-${obj.months}-${obj.dates} ${obj.hours}:${obj.minutes}:${obj.seconds}`);
        },

        valueFormatter: function(timeStamp) {
            if(!this.valueFormat) return timeStamp;

            return dateFormat(timeStamp, this.valueFormatter);
        },
    },
}
</script>

<style>

</style>
